import React, { Component, useEffect, useState } from 'react';
import { Helper } from '../../../src/ToolKit/toolkit.js';

import $ from 'jquery/dist/jquery';
import { Menu, ColumnType, Action, AlertD, YesNo, DropDownBox, SelectBasic, DayTimeSelector, FormDiv, InputBox, Icon, SideView, SideItem, FilterView, SpecValues, ProTable, SimpleButton, CustomHelper, FixedMessage, Captia, Column, NewRecordValue, FromBasic, AddButton, FileProgess, LoadingBar, FromSubmit, InputTextBox, InputPasswordBox, Model, Confirm, RowState } from '../.././Componet';
import { useParams, useNavigate } from "react-router-dom";
import { Route, Link } from "react-router-dom";
import { Modal } from 'bootstrap';
import { DataClass, enums } from '../../../src/ToolKit/DataClass.js'
import { data, param } from 'jquery';


function DetailSerach() {


    const [pageState, setData] = useState({ records: [], isLoaded: false, filter: '', pageTemplate: [], templateId: -1 });


    const serach = () => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('EPayment', 'Serach', data, (data) => {
            setData({ records: data, isLoaded: true, filter: '', pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });

        });
    };



    return <FromBasic>
        
     
        <InputTextBox caption="نام " columnName="fullName" model="fullName" size="33%"></InputTextBox>
      
        <InputTextBox caption="موبایل " columnName="mobile" model="descr" size="33%"></InputTextBox>
        <InputTextBox caption="شناسه  " columnName="objectId" model="objectId" size="33%"></InputTextBox>
        <InputTextBox caption="از مبلغ" columnName="startAmount" model="startAmount" size="25%" customHelper={CustomHelper.isDigitngGroupedNumber}></InputTextBox>
        <InputTextBox caption="تا مبلغ" columnName="endAmount" model="endAmount" size="25%" customHelper={CustomHelper.isDigitngGroupedNumber}></InputTextBox>

        <InputTextBox caption="از تاریخ" columnName="StartDate" model="StartDate" size="25%" customHelper={CustomHelper.isDate}></InputTextBox>
        <InputTextBox caption="تا تاریخ" columnName="EndDate" model="EndDate" size="25%" customHelper={CustomHelper.isDate}></InputTextBox>
        <InputTextBox caption="توضیحات " columnName="descr" model="descr" size="100%"></InputTextBox>
        <center>
            <SimpleButton onClick={serach} title="جست و جو " Icon="View"></SimpleButton>
        </center>

        {pageState.isLoaded &&
            <ProTable rowNumbering={true} datasourcename="records" key={Date().toString()} Records={pageState.records}>
                <Column metaForDisplay={DataClass.PaymentRef.PaymentRefId} />
                <Column metaForDisplay={DataClass.PaymentRef.ERefId} />
                <Column metaForDisplay={DataClass.PaymentRef.ObjectType} />
                <Column metaForDisplay={DataClass.PaymentRef.ObjectId} />
                <Column metaForDisplay={DataClass.PaymentRef.Amount} />
                <Column metaForDisplay={DataClass.PaymentRef.FullName} />
                <Column metaForDisplay={DataClass.PaymentRef.Mobile} />
                <Column metaForDisplay={DataClass.PaymentRef.Descr} />
           
                <Column metaForDisplay={DataClass.PaymentRef.CreateTime} />
                <Column metaForDisplay={DataClass.PaymentRef.SelfRefId} />
                <Column metaForDisplay={DataClass.PaymentRef.PaymentStatus} />
                <Column metaForDisplay={DataClass.PaymentRef.CardNo} />
                <Column metaForDisplay={DataClass.PaymentRef.IP} />
                <Column metaForDisplay={DataClass.PaymentRef.UserAgent} />



            </ProTable>


        }

    </FromBasic>

}
export function EPaymentApp(props) {

    let routes = [
        <Route path="EPaymentReport" element={<DetailSerach />} />,
      

    ];
    return routes;
}
